module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./node_modules/prop-types/lib/has.js
// module id = 377
// module chunks = 0